import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalHeader from "./LocalHeader";
import { ConstructionOutlined } from "@mui/icons-material";

const QrList = () => {
  const dispatch = useDispatch();

  const [check, setCheck] = useState([]);

  const qrList = useSelector(
    (state) => state?.settingReducer?.qrList?.pos_table_masters
  );

  useEffect(() => {
    dispatch(actions?.getQrList());
  }, []);

  function checkAll() {
    if (check.length < qrList.length) setCheck(qrList?.map((el) => el?.id));
    else setCheck([]);
  }

  function checkOne(id) {
    const targetIdx = check.findIndex((el) => el === id);
    if (targetIdx === -1) {
      setCheck([...check, id]);
    } else {
      const copiedArr = [...check];
      copiedArr?.splice(targetIdx, 1);
      setCheck(copiedArr);
    }
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 mt-3">
          <div className="container px-0">
            <LocalHeader />

            <div class="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="menu-sequencing"
                role="tabpanel"
                aria-labelledby="menu-sequencing-tab"
              >
                <div
                  className="tab-pane fade show active "
                  id="qr-list"
                  role="tabpanel"
                  aria-labelledby="qr-list-tab"
                >
                  <div class="row mx-0">
                    <div class="shadowclass mt-md-4 mt-3">
                      <div class="col-12">
                        <div class="counts">
                          <h4 class="event-alert"> Table QR List </h4>
                          <div className="row justify-content-between align-items-center w-100 mx-0">
                            <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                              <div class="search-box mt-0">
                                <form
                                  action="/productions"
                                  id="MenuItemIndexForm"
                                  method="get"
                                  accept-charset="utf-8"
                                >
                                  <input
                                    name="keyword"
                                    placeholder="Search"
                                    type="text"
                                    id="MenuItemKeyword"
                                  />
                                  <input type="submit" />
                                </form>
                              </div>
                            </div>
                            <div class="col-sm-7 col-12 px-0 d-flex align-items-center justify-content-md-end justify-content-between">
                              <button
                                class="btn bordered-btn mx-0 px-1"
                                type="button"
                                id="reGenerateQrs"
                                onClick={() => {
                                  if (check.length === 0) {
                                    dispatch(
                                      actions?.showNotificationWithTimeout(
                                        `${"At least select 1 table"}`,
                                        "error"
                                      )
                                    );
                                    return;
                                  }
                                  dispatch(
                                    actions?.regenerateSelectedQr({
                                      ids: check,
                                    })
                                  );
                                }}
                              >
                                {" "}
                                Re-Generate Selected QRs{" "}
                              </button>
                              <button
                                onClick={() => {
                                  if (check.length === 0) {
                                    dispatch(
                                      actions?.showNotificationWithTimeout(
                                        `${"At least select 1 table"}`,
                                        "error"
                                      )
                                    );
                                    return;
                                  }
                                  dispatch(
                                    actions?.downloadSelectedQr({ ids: check })
                                  );
                                }}
                                class="btn bordered-btn mx-0 px-1 ms-2"
                                type="button"
                                id="downloadQrs"
                              >
                                {" "}
                                Download Selected QRs{" "}
                              </button>
                            </div>
                          </div>

                          <div className="shadowclass mt-0 px-0">
                            <div className="table-responsive">
                              <table className="checklist-table remove-space inventory_table">
                                <thead>
                                  <tr>
                                    <th width="40">
                                      <a class="checkbox avaiCheck">
                                        <input
                                          type="checkbox"
                                          id="checkbox_menu_id"
                                          checked={
                                            check.length === qrList?.length
                                              ? true
                                              : false
                                          }
                                        />
                                        <label
                                          onClick={() => {
                                            checkAll();
                                          }}
                                          for="checkbox_menu_id"
                                        ></label>
                                      </a>
                                    </th>
                                    <th> Table &amp; Room </th>
                                    <th> QR Code ID </th>
                                    <th> Start Date </th>
                                    <th> End Date </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {qrList?.map((el) => (
                                    <tr>
                                      <td>
                                        <a class="checkbox avaiCheck">
                                          <input
                                            type="checkbox"
                                            id={el.id}
                                            checked={
                                              check.findIndex(
                                                (x) => x === el?.id
                                              ) === -1
                                                ? false
                                                : true
                                            }
                                          />
                                          <label
                                            onClick={() => checkOne(el?.id)}
                                            for={el.id}
                                          >
                                            {" "}
                                          </label>
                                        </a>
                                      </td>
                                      <td>
                                        {" "}
                                        <strong>
                                          {" "}
                                          Table - {el?.table_number}{" "}
                                        </strong>
                                        <span>{el?.pos_room?.name}</span>
                                      </td>
                                      <td>
                                        <div
                                          onClick={() => {
                                            dispatch(
                                              actions?.refreshTableQrCode({
                                                id: el?.id,
                                              })
                                            );
                                          }}
                                          class="d-flex align-items-center"
                                        >
                                          <a
                                            href="#_"
                                            class="circle_icon refreshTableQrcode"
                                            val="356"
                                          >
                                            <i class="iconSprites refresh-icon"></i>
                                          </a>
                                          <div className="green-txt mx-2">
                                            {el?.qr_code_id}
                                          </div>
                                        </div>
                                      </td>

                                      <td> {el?.start_date} </td>

                                      <td>{el?.end_date} </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};

export default QrList;
